import React, { Component } from 'react';
import { ACCESS_TOKEN, SIGNIN_AUTH_TOKEN } from '../../settings/shared/constants';
import { Redirect } from 'react-router-dom'
import UserService from '../../services/api/User'
import LoginService from '../../services/api/Login'
import jwt from 'jwt-decode'

class OAuth2RedirectHandler extends Component {
    getUrlParameter(name) {
        name = name.replace(/\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');

        var results = regex.exec(this.props.location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

  getUserRole = () => {
    UserService.getuserRole(localStorage.getItem('Uid'))
      .then((response) => {
        if (response.status === 'SUCCESS') {
          if(response.userDTOS.length > 0){
            localStorage.setItem("lastLogin", response.userDTOS[0].lastLogin);
            let users = response.userDTOS[0];
            localStorage.setItem("role", users.role);
            this.props.history.push('/auth/menu-settings');
          }  
        }
      });
  }

    render() {        
        const token = this.getUrlParameter('token');
        const isSubdomain = this.getUrlParameter('isSubdomain');
        const error = this.getUrlParameter('error');
        if(isSubdomain === "true") {
          if(token) {
            var decoded;
            localStorage.setItem(ACCESS_TOKEN, token);
            decoded = jwt(token);
            localStorage.setItem("Uid", decoded.id);
            this.getUserRole();       
        }
        
        }
        else if(isSubdomain === "true" && error !== "") {
          return <Redirect to={{
            pathname: "/auth/login-page",
            state: { from: this.props.location, msg : error }
        }}/>; 
        }

        else if(isSubdomain === "false" && error !== "") {
          return <Redirect to={{
            pathname: "/auth/login-page",
            state: { from: this.props.location, msg : error }
        }}/>; 

        } else if(isSubdomain === "false") {
          if(token) {
            let tokenParse = jwt(token);
            let email = tokenParse.sub; // Geting email id
            LoginService.auth_accounts(token)
            .then((response) => {
              var decoded;
              if (response.status === 'SUCCESS') {                 
                  /* this block execute if user have multiple tenant list */
                  sessionStorage.setItem(SIGNIN_AUTH_TOKEN, response.authToken);
                  if (response.accountsDTOS !== null) {
                    if (response.accountsDTOS.length > 1) {
                      this.props.history.push({
                        pathname: '/auth/tenants',
                        state: { tenantList: response.accountsDTOS, email: email }
                      })
                    }else{
                      /* here validate with auth tokan and proceed to landing page */
                      let tenantData = {
                        email: email,
                        authToken: sessionStorage.getItem(SIGNIN_AUTH_TOKEN),
                        accountId: response.accountsDTOS[0].accountID
                      }                     
                      LoginService.auth_tenant(tenantData)
                        .then((response) => {
                          if (response.status === 'SUCCESS') {
                            decoded = jwt(response.token);
                            localStorage.setItem(ACCESS_TOKEN, response.token);
                            localStorage.setItem("Uid", decoded.id);
                            sessionStorage.clear(); // here clear the session storage for auth signin 
                            this.getUserRole();
                          }
                        });
                    }
                  }
              }
            });
          }
        }
        return <Redirect to={{
          pathname: "/auth/content-loader",
          state: { from: this.props.location }
      }}/>; 
    }
}

export default OAuth2RedirectHandler;